import axios from '@axios'

export default {
    namespaced: true,
    state: {},
    getters: {},
    mutations: {},
    actions: {
        packages: (cntx, params) => new Promise((resolve, reject) => {
            axios.get('packages', { params })
                .then(response => resolve(response))
                .catch(error => reject(error))
        }),
        list: (cntx, params) => new Promise((resolve, reject) => {
            axios.get('loans', { params })
                .then(response => resolve(response))
                .catch(error => reject(error))
        }),
        show: (cntx, { id }) => new Promise((resolve, reject) => {
            axios.get(`societies/${id}`)
                .then(response => {
                    // Save the response data to localStorage
                    localStorage.setItem('societyData', JSON.stringify(response.data))
                    resolve(response)
                })
                .catch(error => reject(error))
        }),
        create: (cntx, params) => new Promise((resolve, reject) => {
            axios.post('societies', params)
                .then(response => resolve(response))
                .catch(error => reject(error))
        }),
        createLoan: (cntx, params) => new Promise((resolve, reject) => {
            axios.post('loans', params)
                .then(response => resolve(response))
                .catch(error => reject(error))
        }),
        update: (cntx, params) => new Promise((resolve, reject) => {
            axios.put(`societies/${params.id}`, params.data)
                .then(response => resolve(response))
                .catch(error => reject(error))
        }),
        updateLoan: (cntx, params) => new Promise((resolve, reject) => {
            axios.put(`loans/${params.id}`, params.data)
                .then(response => resolve(response))
                .catch(error => reject(error))
        }),
        remove: (cntx, id) => new Promise((resolve, reject) => {
            axios.delete(`societies/${id}`)
                .then(response => resolve(response))
                .catch(error => reject(error))
        }),
        deductable: (cntx, params) => new Promise((resolve, reject) => {
            axios.get('deductibles', { params })
                .then(response => resolve(response))
                .catch(error => reject(error))
        }),
        levies: (cntx, params) => new Promise((resolve, reject) => {
            axios.get('levies', { params })
                .then(response => resolve(response))
                .catch(error => reject(error))
        }),
        associateLevy: (cntx, params) => new Promise((resolve, reject) => {
            axios.post('associate_levy', params)
                .then(response => resolve(response))
                .catch(error => reject(error))
        }),
    },
}
